<template>
  <div class="min-h-screen bg-gray-900 text-white font-sans selection:bg-purple-500 selection:text-white">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>



<script setup lang="ts">
import '~/assets/css/main.css'

import { sweepExpiredItems } from '~/utils/storageWithTTL'

const config = useRuntimeConfig()
const { registerSocketListeners } = useAvatarRegistry()
const defaultTitle = 'Vibe Games'
const defaultDescription = 'Turn any gathering into a live game show with party games built for phones, streams, and quick invites.'
const defaultImage = new URL('/images/streamer_mockup.png', config.public.siteUrl).toString()

onMounted(async () => {
  document.documentElement.dataset.appReady = 'true'
  registerSocketListeners()
  sweepExpiredItems(['player_id_', 'player_name_', 'player_avatar_'])
  
  try {
    const { version, sha } = await $fetch('/api/version')
    console.log(`%cVibe Games v${version} (${sha})`, 'color: #9333ea; font-weight: bold; font-size: 1.2em;')
  } catch {
    // Fallback to runtime config if API fails
    const config = useRuntimeConfig()
    console.log(`%cVibe Games v0.1.0 (${config.public.gitSha})`, 'color: #9333ea; font-weight: bold; font-size: 1.2em;')
  }
})

onErrorCaptured((err, instance, info) => {
  console.error('[App Error Captured]:', err)
  console.error('Instance:', instance)
  console.error('Info:', info)
  // Prevent the error from propagating further if needed
  // return false 
})

useHead({
  title: defaultTitle,
  titleTemplate: (titleChunk) => titleChunk && titleChunk !== defaultTitle
    ? `${titleChunk} | ${defaultTitle}`
    : defaultTitle,
  meta: [
    { name: 'theme-color', content: '#2E3192' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' }
  ],
  link: [
    { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
    { rel: 'manifest', href: '/site.webmanifest' },
    { rel: 'canonical', href: config.public.siteUrl }
  ]
})

useSeoMeta({
  title: defaultTitle,
  applicationName: defaultTitle,
  appleMobileWebAppTitle: defaultTitle,
  description: defaultDescription,
  ogSiteName: defaultTitle,
  ogLocale: 'en_US',
  ogType: 'website',
  ogTitle: defaultTitle,
  ogDescription: defaultDescription,
  ogUrl: config.public.siteUrl,
  ogImage: defaultImage,
  ogImageAlt: 'Vibe Games preview showing a phone-first party game experience',
  twitterCard: 'summary_large_image',
  twitterTitle: defaultTitle,
  twitterDescription: defaultDescription,
  twitterImage: defaultImage,
  twitterImageAlt: 'Vibe Games preview showing a phone-first party game experience'
})
</script>
